import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { PAGE } from '../../constants/url';

import { ButtonAddChat, BoxChatRecord, NavLinkStyle, TxtStyle } from './leftnavStyle';
import { HomeRoundedIcon, FavoriteRoundedIcon, FeedRoundedIcon } from '../customStyles/images';
import theme from '../../theme';


const NavItem = (props) => {
  const location = useLocation();
  const { userAuth, isDesktop, isMobile, drawerOpen } = props;
  const NavData = _.filter(PAGE, el => el.nav === true);

  return (
    <>
      {
        userAuth &&
        <Box>
          {
            NavData.map((data, index) => {
              return (
                <Tooltip
                  key={`${index}_${data.id}`}
                  title={data.name}
                  placement='right'
                >
                  <NavLinkStyle
                    to={data.path}
                    ismobile={isMobile.toString()}
                    draweropen={drawerOpen.toString()}
                    disabled={data.disabled}
                    activepath={data.path}
                    onClick={(e) => {
                      if (data.path === location.pathname || data.disabled) {
                        e.preventDefault();
                      } else {
                        props.toggleDrawer();
                      }
                    }}
                  >
                    {data.icon}

                    <Typography
                      component="span"
                      style={TxtStyle}
                      sx={{
                        display: !drawerOpen && isDesktop ? 'none' : 'block',
                      }}
                    >
                      {data.name}
                    </Typography>

                  </NavLinkStyle>
                </Tooltip>
              )
            })
          }
        </Box >
      }
    </>
  )
}


export default NavItem;